import FormResponseContainer from './FormResponseContainer';

export default FormResponseContainer;
